<template>
  <div
    class="input-wrapper awsome-wrapper starts-appoitment all-day-wrapper timing-wrapper show-awsome-select main-content"
  >
    <div class="title-wrapper position-relative">
      <span class="ver-center">Start Time</span>
    </div>
    <div class="content-wrapper position-relative">
      <div
        class="date-wrapper ver-center show-awsome-select calendar-wrapper text-right r-10 toggle-calendar full-width"
      >
        <input
          type="time"
          name="start-time"
          class="text-only-input ml-10"
          :value="formattedTime"
          @change="setTimeLocal"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { dateAndTimeMixin } from "../../../../mixins/dateAndTimeMixin";

export default {
  mixins: [dateAndTimeMixin],
  computed: {
    ...mapGetters({
      date: "getDate", // Gets the currently selected date
      time: "getStartTime", // Gets the start time
      getEdit: "getEdit"
    }),
    formattedTime() {
      return this.formatTime24(this.time.hr, this.time.min);
    }
  },
  methods: {
    ...mapMutations({
      setTime: "setStartTime" // Set the start time
    }),

    /**
     * When time is changed, change the time in global state
     */
    setTimeLocal(event) {
      const time = event.target.value.split(":");
      this.setTime({ hr: parseInt(time[0]), min: parseInt(time[1]), sec: 0 });
    }
  },
  created() {
    // Only setting the start repeat as repeat date when it is not repeat
    if (!this.getEdit.isEdit) {
      const today = new Date();
      this.setTime({ hr: today.getHours(), min: today.getMinutes(), sec: 0 });
    }
  }
};
</script>

<style scoped></style>
